import {BaseApiService} from "./baseApi.service";

export class AddressService extends BaseApiService {
    constructor() {
        super();
    }

    create(addressDataObj) {
        const url = `${process.env.VUE_APP_BASE_URL}/v1/address/create`
        return this.sendPostRequest(url, addressDataObj)
    }
}
